import { useEffect } from 'react';

import { useSelector } from 'react-redux';

import { formatISO, addYears } from 'date-fns';

import { ROOMS_LAST_VISITED_UI } from '@framework/constants/userStates';
import { addEndSlashForUrl } from '@framework/cookbook/string.utils';

import useAuthenticationStatus from '@hooks/useAuthenticationStatus';
import useLoggedUser from '@hooks/useLoggedUser';
import useUserStateMutate from '@hooks/useUserStateMutate';

import { getCurrentContentView, getCurrentAppSection } from '@redux/selectors/AppSelector';

const useLastVisited = () => {
    const currentContentView = useSelector(getCurrentContentView);
    const currentSection = useSelector(getCurrentAppSection);
    const { data: proofStatus } = useAuthenticationStatus();
    const { data: loggedUser } = useLoggedUser({
        enabled: Boolean(proofStatus?.isAuthenticated)
    });
    const { mutate: mutateUserState } = useUserStateMutate();

    const handleLastVisitedChange = () => {
        const url = `${window.location.pathname}${window.location.search}`;
        const urlWithSlash = addEndSlashForUrl(url);
        const userState = {
            stateType: 'string',
            stateId: String(loggedUser?.id),
            value: urlWithSlash,
            stateName: ROOMS_LAST_VISITED_UI,
            expiry: formatISO(addYears(new Date(), 10))
        };

        mutateUserState(userState);
    };

    useEffect(() => {
        if (currentContentView && currentSection && loggedUser?.id) {
            handleLastVisitedChange();
        }
    }, [currentContentView, currentSection, loggedUser?.id]);

    return handleLastVisitedChange;
};

export default useLastVisited;
